import type { UIStringsOverride } from "../i18n-ui.ts";

/** Japanese (ja) UI strings. */
export const ja: UIStringsOverride = {
  actions: {
    addToCursor: "Cursor に追加",
    addToVscode: "VS Code に追加",
    askAI: "このページについて AI に質問",
    connectMcp: "MCP に接続",
    copied: "コピーしました！",
    copyClaudeCode: "Claude Code コマンドをコピー",
    copyCode: "コードをコピー",
    copyCodex: "Codex コマンドをコピー",
    copyMarkdown: "Markdown としてコピー",
    copyServerUrl: "サーバー URL をコピー",
    edit: "GitHub で編集",
    export: "エクスポート",
    exportEpub: "EPUB にエクスポート",
    exportPdf: "PDF にエクスポート",
    generating: "生成中…",
    openIn: "{name} で開く",
    openInChat: "チャットで開く",
    scrollToTop: "トップに戻る",
  },
  ask: {
    ai: "AI",
    clear: "会話をクリア",
    close: "閉じる",
    copy: "会話をコピー",
    empty: "ドキュメントについて質問してください。",
    error: "申し訳ありません。問題が発生しました。",
    label: "質問する",
    placeholder: "質問を入力…",
    send: "送信",
    tip: "ヒント: 次のキーでチャットを開閉できます",
    title: "AI に質問",
    you: "あなた",
  },
  banner: { dismiss: "お知らせを閉じる" },
  changelog: {
    description: "製品のアップデートとリリースノート。",
    showReleases: "{version} のリリースを表示",
    title: "変更履歴",
  },
  content: {
    diagramError: "この図を表示できませんでした。",
  },
  feedback: {
    no: "いいえ",
    question: "このページは役に立ちましたか？",
    thanks: "フィードバックありがとうございます！",
    yes: "はい",
  },
  languageSwitcher: { label: "言語", untranslated: "未翻訳" },
  nav: {
    back: "戻る",
    breadcrumb: "パンくずリスト",
    closeNavigation: "ナビゲーションを閉じる",
    deprecated: "非推奨",
    featured: "注目",
    githubRepository: "GitHub リポジトリ",
    navigation: "ナビゲーション",
    primary: "メイン",
    sections: "セクション",
    toggleNavigation: "ナビゲーションを切り替え",
    toggleTheme: "カラーテーマを切り替え",
  },
  notFound: {
    description: "お探しのページが見つかりませんでした。",
    home: "ホームに戻る",
    title: "ページが見つかりません",
  },
  page: {
    lastUpdated: "最終更新",
    next: "次へ",
    pagination: "ページネーション",
    previous: "前へ",
    skipToContent: "コンテンツにスキップ",
  },
  search: {
    all: "すべて",
    allLanguages: "すべての言語",
    askAi: "AI に質問",
    askAiHint: "AI からすぐに回答を得る",
    button: "検索",
    devOnly: "検索は本番ビルドで利用できます。",
    error: "問題が発生しました。もう一度お試しください。",
    label: "ドキュメントを検索",
    navigate: "移動",
    noResults: "結果が見つかりませんでした。",
    open: "開く",
    placeholder: "ドキュメントを検索…",
    popular: "人気",
    preview: "プレビュー",
    results: "結果",
  },
  toc: { title: "このページの内容" },
};
